module.exports = __webpack_public_path__ + "a768e7de/img/comment-question-icon.7dd26e04.svg";